/**
 * Matching enum for the `end_user.status` column in the database.
 */
export enum HubStatus {
  NONE = "none",
  FLAGGED = "flagged",
}

export type HubStatusType = `${HubStatus}`;

/**
 * Matching enum for query params in the Hub page.
 */
export enum HubTab {
  ALL = "all",
  FLAGGED = "flagged",
  TRANSFERRED = "transferred",
  RESOLVED = "resolved",
}

export const HUB_TABS = [HubTab.ALL, HubTab.FLAGGED, HubTab.TRANSFERRED, HubTab.RESOLVED] as const;

export type HubTabType = `${HubTab}`;
